import { apiClient } from "@/lib/api-client"
import { DocumentDto } from "../entities/DocumentDto"
import {
  DocumentVersionDto,
  DocumentDownloadDto,
} from "../dtos/DocumentPermissionDto"

export const documentService = {
  getAllDocuments: async (
    organizationId: string,
    folderId?: string,
  ): Promise<DocumentDto[]> => {
    const url = folderId
      ? `/organizations/${organizationId}/documents`
      : `/organizations/${organizationId}/documents/all`
    const response = await apiClient.get<DocumentDto[]>(url, {
      params: folderId ? { folderId } : undefined,
    })
    return response.data
  },

  getDocument: async (
    organizationId: string,
    id: string,
  ): Promise<DocumentDto> => {
    const response = await apiClient.get<DocumentDto>(
      `/organizations/${organizationId}/documents/${id}`,
    )
    return response.data
  },

  downloadDocument: async (
    organizationId: string,
    id: string,
  ): Promise<DocumentDownloadDto> => {
    const response = await apiClient.get<DocumentDownloadDto>(
      `/organizations/${organizationId}/documents/${id}/download`,
    )
    return response.data
  },

  uploadDocument: async (
    organizationId: string,
    formData: FormData,
  ): Promise<DocumentDto> => {
    const response = await apiClient.post<DocumentDto>(
      `/organizations/${organizationId}/documents`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    )
    return response.data
  },

  updateDocument: async (
    organizationId: string,
    id: string,
    data: Partial<Pick<DocumentDto, "fileName" | "status">>,
  ): Promise<DocumentDto> => {
    const response = await apiClient.put<DocumentDto>(
      `/organizations/${organizationId}/documents/${id}`,
      data,
    )
    return response.data
  },

  deleteDocument: async (organizationId: string, id: string): Promise<void> => {
    await apiClient.delete(`/organizations/${organizationId}/documents/${id}`)
  },

  restoreDocument: async (
    organizationId: string,
    id: string,
  ): Promise<DocumentDto> => {
    const response = await apiClient.post<DocumentDto>(
      `/organizations/${organizationId}/documents/${id}/restore`,
    )
    return response.data
  },

  getDocumentVersions: async (
    organizationId: string,
    id: string,
  ): Promise<DocumentVersionDto[]> => {
    const response = await apiClient.get<DocumentVersionDto[]>(
      `/organizations/${organizationId}/documents/${id}/versions`,
    )
    return response.data
  },

  moveDocument: async (
    organizationId: string,
    documentId: string,
    folderId: string | null,
  ): Promise<void> => {
    await apiClient.patch(
      `/organizations/${organizationId}/documents/${documentId}/move`,
      { folderId },
    )
  },

  getEmployeeDocuments: async (
    organizationId: string,
    employeeId: string,
  ): Promise<DocumentDto[]> => {
    const response = await apiClient.get<DocumentDto[]>(
      `/organizations/${organizationId}/documents/employee/${employeeId}`,
    )
    return response.data
  },
}
